/* quick-view.js */
class QuickView {
  constructor() {
    this.modal = document.getElementById('QuickViewModal');
    this.triggers = document.querySelectorAll('.js-quick-view-trigger');
    
    if (!this.modal) return;
    
    this.closeBtn = this.modal.querySelector('.quick-view__close');
    this.overlay = this.modal.querySelector('.quick-view__overlay');
    this.content = this.modal.querySelector('.quick-view__content');
    
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const productHandle = trigger.dataset.productHandle;
        this.open(productHandle);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
    
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  async open(handle) {
    if (!handle) return;
    
    try {
      // Show loading state
      if (this.content) this.content.innerHTML = '<div class="loader">Loading...</div>';
      this.modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      
      // Fetch product data via Section Rendering API (requires a specific section setup)
      // For this skeleton, we'll fetch product.js as a fallback placeholder
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      
      if (this.content) {
        this.content.innerHTML = `
          <div class="quick-view__product">
            <h2>${product.title}</h2>
            <p>Price: ${product.price / 100}</p>
            <form action="/cart/add" method="post">
              <input type="hidden" name="id" value="${product.variants[0].id}">
              <button type="submit" class="button">Add to Cart</button>
            </form>
          </div>
        `;
      }
    } catch (error) {
      console.error('Error fetching quick view data', error);
      if (this.content) this.content.innerHTML = '<p>Error loading product data.</p>';
    }
  }

  close() {
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickView();
});
